import axios from "axios";

import type { PromptCategory } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client/queryOption";

export const getPromptCategories = queryOptions({
	queryKey: "promptCategories",
	async queryFn() {
		const response = await axios.get<PromptCategory[]>(`${env.apiUrl}/prompt-categories`);

		return response.data;
	},
});

export async function createPromptCategory(name: string) {
	const response = await axios.post<PromptCategory>(`${env.apiUrl}/prompt-categories`, { name });

	return response.data;
}

export async function updatePromptCategory({ id, name }: { id: string; name: string }) {
	await axios.put(`${env.apiUrl}/prompt-categories/${id}`, { name });
}

export async function deletePromptCategory(id: string) {
	await axios.delete(`${env.apiUrl}/prompt-categories/${id}`);
}
